module.exports = __webpack_public_path__ + "media/images/bg-results-pattern-a031f298af20c2096734522b125477cf.jpg";